import { render, staticRenderFns } from "./PluginFacebookPixel.vue?vue&type=template&id=5a5c5d02"
import script from "./PluginFacebookPixel.vue?vue&type=script&lang=js"
export * from "./PluginFacebookPixel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a5c5d02')) {
      api.createRecord('5a5c5d02', component.options)
    } else {
      api.reload('5a5c5d02', component.options)
    }
    module.hot.accept("./PluginFacebookPixel.vue?vue&type=template&id=5a5c5d02", function () {
      api.rerender('5a5c5d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginFacebookPixel.vue"
export default component.exports